import React from 'react'
import { 
    Pagination, 
    PaginationItem,
    PaginationLink
} from 'reactstrap'

function PaginationComponent({currentPage, setCurrentPage, totalPages}) {
      // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Handle next page
    const handleNext = () => {
        if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
        }
    };

    // Handle previous page
    const handlePrevious = () => {
        if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
        }
    };

  return (
    <div>
        <Pagination aria-label="Page navigation example">
        {/* First page link */}
        <PaginationItem disabled={currentPage === 1}>
            <PaginationLink first href="#" onClick={() => handlePageChange(1)} />
        </PaginationItem>

        {/* Previous page link */}
        <PaginationItem disabled={currentPage === 1}>
            <PaginationLink previous href="#" onClick={handlePrevious} />
        </PaginationItem>

        {/* Page numbers */}
        {[...Array(totalPages)].map((_, index) => (
            <PaginationItem key={index} active={currentPage === index + 1}>
            <PaginationLink href="#" onClick={() => handlePageChange(index + 1)}>
                {index + 1}
            </PaginationLink>
            </PaginationItem>
        ))}

        {/* Next page link */}
        <PaginationItem disabled={currentPage === totalPages}>
            <PaginationLink next href="#" onClick={handleNext} />
        </PaginationItem>

        {/* Last page link */}
        <PaginationItem disabled={currentPage === totalPages}>
            <PaginationLink last href="#" onClick={() => handlePageChange(totalPages)} />
        </PaginationItem>
        </Pagination>
  </div>
  )
}

export default PaginationComponent
